import React from 'react';
import unCheck from "../../../Images/unCheck.svg";
import Check from "../../../Images/check.svg";
import ProgressIndicator1 from "../../../Images/ProgressIndicator/progressIndicator1.svg";
import ProgressIndicator0 from "../../../Images/ProgressIndicator/progressIndicator0.svg";
import ProgressIndicator100 from "../../../Images/ProgressIndicator/progressIndicatorFull.svg";
import ProgressIndicator25 from "../../../Images/ProgressIndicator/ProgressIndicator25.svg";
import ProgressIndicator50 from "../../../Images/ProgressIndicator/ProgressIndicator50.svg";
import ProgressIndicator75 from "../../../Images/ProgressIndicator/ProgressIndicator75.svg";
import ProgressIndicator33 from "../../../Images/ProgressIndicator/ProgressIndicator33.svg";
import ProgressIndicator66 from "../../../Images/ProgressIndicator/ProgressIndicator66.svg";

const ProbingTab = ({ probingCheck, item, handleRadioChange, tabId }) => {
  const parser = new DOMParser();
  const doc = parser.parseFromString(item, 'text/html');
  const elements = doc.body.childNodes;

  const radioButtons = [];
  let currentHeader = null; // Tracks the latest <p> tag
  let totalItemsCount = 0; // Total number of radio buttons

  elements.forEach((element, index) => {
    if (element?.tagName === 'P') {
      // Set the current header for subsequent lists
      radioButtons.push(
        <div key={`header-${index}`} style={{ marginLeft: '10px', fontWeight: 'bold', color: '#220046', marginTop: '10px' }}>
          {element.textContent.trim()}
        </div>
      );
      totalItemsCount += 1;
    } else if (element?.tagName === 'UL' || element?.tagName === 'OL') {
      // Generate list items only if a header exists
      const items = Array.from(element?.children).map((child, childIndex) => ({
        text: child.textContent.trim(),
        value: `option-${tabId}-${index}-${childIndex}`,
      }));

      // Add list items as radio buttons
      items.forEach((item) => {
        radioButtons.push(
          <div
            key={item.value}
            style={{
              marginLeft: '20px',
              overflowWrap: 'break-word',
              display: 'flex',
              alignItems: 'center',
              margin: '10px 14px 14px 14px',
            }}
            className='system-check-para'
          >
            <img
              id={item.value}
              name={`probing-${tabId}`}
              alt="radioCheck"
              value={item.text}
              src={probingCheck.includes(item.text) ? Check : unCheck}
              onClick={() => handleRadioChange(tabId, item.text)}
              style={{
                width: "20px",
                height: "20px",
                position: "relative",
                left: "2px",
                marginTop: '2px',
                cursor: 'pointer',
              }}
            />
            <div
              className="probe-list"
              style={{
                textDecoration: probingCheck.includes(item.text) ? "line-through" : "none",
                marginLeft: "14px",
                color: "#220046",
                alignItems: "center",
                display: "flex",
              }}
            >
              {item.text}
            </div>
          </div>
        );
      });

      totalItemsCount += items.length; // Increment total count of radio buttons
    }
  });

  const progressPercentage =
    totalItemsCount === 0 ? 0 : (probingCheck.length / totalItemsCount) * 100;

  let progressLevel;
  if (progressPercentage === 0) {
    progressLevel = 0;
  } else if (progressPercentage <= 25) {
    progressLevel = 25;
  } else if (progressPercentage <= 33) {
    progressLevel = 33;
  } else if (progressPercentage <= 50) {
    progressLevel = 50;
  } else if (progressPercentage <= 66) {
    progressLevel = 66;
  } else if (progressPercentage <= 75) {
    progressLevel = 75;
  } else {
    progressLevel = 100;
  }

  const getProgressIndicatorSrc = (level) => {
    switch (level) {
      case 0:
        return ProgressIndicator0;
      case 25:
        return ProgressIndicator25;
      case 33:
        return ProgressIndicator33;
      case 50:
        return ProgressIndicator50;
      case 66:
        return ProgressIndicator66;
      case 75:
        return ProgressIndicator75;
      case 100:
        return ProgressIndicator100;
      default:
        return ProgressIndicator0;
    }
  };

  return (
    <div>
      <div className="sub-headers-probe">
        <div className="header-prob">PROBING</div>
        <span className="sub-header-page">
          <div style={{ display: "flex", width: "52px", gap: "8px" }}>
            <div className="selected-probe">
              {probingCheck.length}/{totalItemsCount}
            </div>
            <img
              style={{ width: "24px", height: "24px" }}
              src={
                probingCheck.length === 0
                  ? ProgressIndicator0
                  : getProgressIndicatorSrc(progressLevel)
              }
              alt="progress"
            />
          </div>
        </span>
      </div>
      {radioButtons.length > 0 ? radioButtons : <div style={{ marginLeft: '10px' }}>NA</div>}
    </div>
  );
};

export default ProbingTab;
